import t from 'tcomb';
import Behaviour_Needed from './Behaviour_Needed';
import Behaviour_Ok from './Behaviour_Ok';
import Behaviour_Ko from './Behaviour_Ko';
import Captcha from './Captcha';

const Behaviour_Response = t.union([Behaviour_Needed, Behaviour_Ok, Behaviour_Ko, Captcha]);

Behaviour_Response.dispatch = function(x) {
  switch (x.type) {
    case 'needed':
      return Behaviour_Needed;
    case 'ok':
      return Behaviour_Ok;
    case 'ko':
      return Behaviour_Ko;
    case 'captcha':
      return Captcha;
  }
  return x.constructor;
};


module.exports = Behaviour_Response;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Behaviour_Response.js
 **/